// extracted by mini-css-extract-plugin
export default {"overview-container":"activity-overview_overview-container__3tX+7","title":"activity-overview_title__2bC2L","overview-wrapper":"activity-overview_overview-wrapper__vXwgq"};